<template>
  <svg viewBox="0 0 212 212" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M174 18H38C26.9543 18 18 26.9543 18 38V114.823C10.5464 119.889 4.35618 126.675 0 134.61V38C0 17.0132 17.0132 0 38 0H174C194.987 0 212 17.0132 212 38L212 127L127 212H77.3901C85.3253 207.644 92.1111 201.454 97.1767 194H121.5V144C121.5 131.297 131.797 121 144.5 121H194V38C194 26.9543 185.046 18 174 18Z"
      fill="#1F2329"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M100 162C100 189.614 77.6142 212 50 212C22.3858 212 0 189.614 0 162C0 134.386 22.3858 112 50 112C77.6142 112 100 134.386 100 162ZM43 190V169H22V155H43V134H57V155H78V169H57V190H43Z"
      fill="#1F2329"
    />
  </svg>
</template>
